import React from "react";
import Hero from "@/components/Hero";
import Navbar from "@/components/Navbar";
import VideoWelcome from "@/components/VideoWelcome";
import BotShowcase from "@/components/BotShowcase";
import Testimonials from "@/components/Testimonials";
import HowItWorks from "@/components/HowItWorks";
import FAQ from "@/components/FAQ";

const Index = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <Hero />
      <VideoWelcome />
      <Testimonials />
      <BotShowcase />
      <HowItWorks />
      <FAQ />
    </div>
  );
};

export default Index;
